import React from 'react'
import { Modal } from '@components/ui'

type ChartingSelectConditionFirstModalProps = {
  show: boolean
  onHide: () => void
}

const ChartingSelectConditionFirstModal: React.FC<
  ChartingSelectConditionFirstModalProps
> = ({ show, onHide }) => (
  <Modal
    open={show}
    onClose={onHide}
    size="xs"
    title="Select condition first"
    description="Please select a condition (Caries, Filling, Erosion, Inlay, Onlay, Crown, or Abrasion) before selecting a surface."
    primaryLabel="Okay"
    secondaryLabel=""
    onPrimaryClick={onHide}
  />
)

export default ChartingSelectConditionFirstModal
